module.exports = __webpack_public_path__ + "static/media/worry-depression-map.23d22226.png";